module.exports = __webpack_public_path__ + "img/call_silent.d7187f28.svg";